import { render, staticRenderFns } from "./newPlan.vue?vue&type=template&id=55fb41a4"
import script from "./newPlan.vue?vue&type=script&lang=js"
export * from "./newPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports